import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppLayoutComponent } from "../app-layout/app-layout.component";
import { ButtonComponent } from "../button/button.component";

@Component({
    selector: "app-page-not-found",
    imports: [AppLayoutComponent, ButtonComponent],
    templateUrl: "./page-not-found.component.html",
    styleUrl: "./page-not-found.component.scss"
})
export class PageNotFoundComponent {
  constructor(private readonly router: Router) {}

  goToHome() {
    this.router.navigate([""]);
  }
}
